
import { Component, Vue, Prop, Emit, Watch } from "vue-property-decorator";
import Pop from "../components/blue-pop.vue";
import InputNumberV3 from "@/views/ai-builder-v3/components/inputNumberV3.vue";
import Dimensions, { Dimension } from "@/lib/dimension/dimension";
import { QuestionV2 } from "@/lib/model/exambuilder/question-v2";
import {
  ThousandsQuestion,
  ThousandsComponent,
  ThousandsQsSearch,
  ThousandsTask,
  ThousandsDesc
} from "@/lib/model/exambuilder/exam-component/thousands-question";
import request from "@/lib/request/request";
import IntroduceCard from "@/views/ai-builder-component/components/introduce-card.vue";
import HinaSwitch from "@/views/ai-builder-component/baseComponent/hina-switch.vue";
import { ElForm } from "element-ui/types/form";
import HinaEmpty from "@/views/ai-builder-component/baseComponent/hina-empty.vue";

@Component({
  components: {
    HinaEmpty,
    HinaSwitch,
    Pop,
    InputNumberV3,
    IntroduceCard
  }
})
export default class ThousandQuestion extends Vue {
  @Prop() formItemData!: {
    questionSelectedList: QuestionV2[];
    thousandsTask: ThousandsComponent;
  }; // 组件数据
  @Prop({ default: "" }) builder!: string; // 创建面试来源

  get thousandsTask() {
    return this.formItemData.thousandsTask;
  }

  isProd = process.env.NODE_ENV === "production";
  thousandsType = 1;
  dimensionListDef: Dimension[] = []; //标准维度
  qsLoading = false;
  qrLoading = false;
  pollTimer = 0;
  timeoutTimer = 0;
  thousandsQr = "";
  normalQr = "";
  formFold = !!this.thousandsTask.thousandsDescList.length;
  qsFold = !!this.thousandsTask.thousandsDescList.length;
  thousandsTaskId = "";
  normalTaskId = "";

  rules = {
    title: [{ required: true, message: "", trigger: ["change"] }],
    duty: [{ required: true, message: "", trigger: ["change"] }]
  };

  get questionList() {
    return this.formItemData.questionSelectedList.filter(item => {
      return (
        item.dimensionKeyList?.length === 1 &&
        this.dimensionListDef.some(
          d => d.dimensionKey === item.dimensionKeyList[0]
        ) &&
        item.getQuestionTypeText() === "视频题"
      );
    });
  }

  async getAllDimension() {
    const p: any = {
      questionPositionIdList: [],
      questionIndustryIdList: [],
      isExamEnv: 1
    };
    const res = await Dimensions.getAll(p);
    this.dimensionListDef = res.list.filter(
      (d: Dimension) =>
        d.isSystemDimension === 1 && d.isFromSystemDimension !== 1
    );
  }

  mounted() {
    this.getAllDimension();
  }

  @Watch("questionList.length", { immediate: true })
  handleChangeQuestionList() {
    if (!this.questionList.length) {
      this.thousandsTask.use === 2;
    }
  }

  get selectedQuestions() {
    return this.questionList.filter(item =>
      this.thousandsTask.questions.includes(item.questionId)
    );
  }

  beforeSetThouands() {
    if (this.builder === "MOKA_V2") {
      this.$message.warning("敬请期待");
    }
  }

  setThouands(value: number) {
    if (value === 1) {
      this.thousandsTask.questions = this.questionList.map(
        item => item.questionId
      );
    } else {
      this.thousandsTask.questions = [];
    }

    this.$emit("setBar", false);
    this.setGlobal();
  }

  setGlobal() {
    this.$emit("setGlobal");
  }

  async getThousandQuestion() {
    (this.$refs.formRef as ElForm).validate(async valid => {
      if (!valid) {
        const el = document.querySelector(".main-card .right");

        el?.scrollTo({
          left: 0,
          top: 0,
          behavior: "smooth"
        });
        return this.$message.error("请完善补充岗位信息");
      }

      this.qsLoading = true;

      const thousandsQsSearch = new ThousandsQsSearch().assign({
        jobConfig: this.thousandsTask.jobConfig,
        taskList: this.selectedQuestions.map(item => ({
          questionId: item.questionId,
          dimensionKey: item.dimensionKeyList[0]
        }))
      });

      const res = await thousandsQsSearch.get().finally(() => {
        this.qsLoading = false;
      });

      if (!res.length) return;

      this.formFold = true;
      this.qsFold = true;

      this.thousandsTask.thousandsQuestion = this.selectedQuestions.map(
        (item, index) =>
          new ThousandsQuestion().assign({
            question: item,
            thousandsDescList: res[index]
          })
      );
    });
  }

  @Watch("thousandsTask.thousandsQuestion", { deep: true })
  handleChangeThousandQuestion() {
    this.$emit("setBar", false);
    this.thousandsTask.thousandsDescList = this.thousandsTask.thousandsQuestion.map(
      item =>
        new ThousandsDesc().assign({
          questionId: item.question.questionId,
          thousandsDesc: item.thousandsDescList[item.selectedIndex]
        })
    );
  }

  changeAllQuestion() {
    this.thousandsTask.thousandsQuestion.forEach(item => item.change());
  }

  async createQrTask() {
    const thousandsTask = new ThousandsTask().assign({
      list: this.thousandsTask.thousandsQuestion.map(item => ({
        questionId: item.question.questionId,
        questionDesc: item.question.desc,
        thousandsQuestionDesc: item.thousandsDescList[item.selectedIndex]
      }))
    });
    const normalTask = new ThousandsTask().assign({
      list: this.questionList.map(item => ({
        questionId: item.questionId,
        questionDesc: item.desc,
        thousandsQuestionDesc: ""
      }))
    });

    this.thousandsTaskId = await thousandsTask.createTask();
    this.normalTaskId = await normalTask.createTask();

    this.qrLoading = true;
    this.pollTimer = setInterval(async () => {
      const res = await thousandsTask.get(this.thousandsTaskId);

      // 生成题目成功
      if (res.progress === 2) {
        clearInterval(this.pollTimer);
        clearTimeout(this.timeoutTimer);
        this.pollTimer = 0;
        this.timeoutTimer = 0;
        this.qrLoading = false;
        this.thousandsQr = await this.makeQr(this.thousandsTaskId);
        this.normalQr = await this.makeQr(this.normalTaskId);
      }
    }, 2000);

    this.timeoutTimer = setTimeout(() => {
      clearInterval(this.pollTimer);
      this.pollTimer = 0;
      this.qrLoading = false;
    }, 40000);
  }

  async makeQr(taskId: string) {
    const res = await request.postInterviewApi("public/common/wsaCode", {
      scene: `${
        process.env.NODE_ENV === "production" ? 0 : 1
      }_thousandsQr_${taskId}`,
      page: "pages/index/index"
    });

    if (res.data.code !== 0) return "";

    return res.data.data.base64string;
  }

  reset() {
    this.thousandsTask.thousandsQuestion = [];
    this.qsLoading = false;
    this.qrLoading = false;
    this.pollTimer = 0;
    this.timeoutTimer = 0;
    this.thousandsQr = "";
    this.normalQr = "";
    this.thousandsTask.thousandsDescList = [];
    this.formFold = false;
    this.qsFold = false;
    this.thousandsQr = "";
    this.normalQr = "";
  }

  // 校验数据
  formItemCheck() {
    return new Promise((resolve, reject) => {
      if (this.thousandsTask.use !== 1) return resolve("");

      if (this.thousandsTask.thousandsDescList.length) return resolve("");

      this.$message.error("请先生成千人千问题目并选择");

      resolve("ThousandQuestion");
    });
  }
}
